import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import {
  injectIntl,
  SmartDialog,
  SmartForm,
} from 'components';
import { bulkCreateSocialContacts } from 'redux/socialContacts/actions';
import AutoFill from './AutoFill';

const styles = () => ({
  contactChip: { margin: 5 },
  importBtn: {
    borderRadius: 5,
    marginLeft: 20,
    backgroundColor: 'white',
    color: '#09f',
  },
  importBtnLabel: {
    fontSize: 12,
    fontWeight: 600,
  },
  titleBlock: {
    alignItems: 'center',
    display: 'flex',
  },
});

class AddSourceDialog extends Component {
  static contextTypes = {
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    isVendor: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    saveButtonTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    info: PropTypes.shape({}),

    bulkCreateSocialContacts: PropTypes.func.isRequired,
    createItem: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isRetailPage: PropTypes.bool,
  };

  static defaultProps = {
    isVendor: false,
    saveButtonTitle: '',
    info: {},
    isRetailPage: false,
  };

  state = {
    info: this.props.info,
    refreshCount: 0,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.info !== nextProps.info) {
      this.setState({
        info: nextProps.info,
      });
    }
  }

  onReceiveContacts = (contacts) => {
    const filteredContacts = contacts.map(({
      email: emails,
      first_name: firstName,
      last_name: lastName,
    }) => ({
      email: emails[0].address,
      firstName,
      lastName,
    }));
    this.props.bulkCreateSocialContacts({ contacts: filteredContacts });
    return true;
  }

  onImportContacts = (contacts) => {
    this.setState({
      info: {
        companyName: contacts[0].companies && contacts[0].companies.length > 0 ? contacts[0].companies[0] : '',
        email: contacts[0].selectedEmail(),
        firstName: contacts[0].first_name,
        lastName: contacts[0].last_name,
        selected: true,
      },
      refreshCount: this.state.refreshCount + 1,
    });
  }

  onSave = (data) => {
    const { createItem, isRetailPage } = this.props;
    const { info, refreshCount } = this.state;
    const customData = data;
    customData.email = info.email ? info.email.trim() : '';
    customData.asConsumer = isRetailPage;
    customData.onSuccess = () => {
      this.setState({
        info: {},
        refreshCount: refreshCount + 1,
      });
    };
    createItem(customData);
  }

  onSelect = (info) => {
    this.setState({
      info: {
        companyName: info.profile.companyName,
        email: info.email,
        firstName: info.profile.firstName,
        lastName: info.profile.lastName,
        selected: true,
      },
      refreshCount: this.state.refreshCount + 1,
    });
  }

  handleClose = () => {
    this.setState({
      info: {},
      refreshCount: 0,
    });
    this.props.onClose();
  }

  render() {
    const { isConsumer } = this.context;
    const {
      classes,
      formatMessage,
      isVendor,
      open,
      saveButtonTitle,
      title,
      isRetailPage,
    } = this.props;
    const { info, refreshCount } = this.state;

    const fields = [];
    if (!isRetailPage) {
      fields.push({
        fieldName: 'companyName',
        fullWidth: true,
        kind: 'input',
        label: formatMessage('Company'),
        name: 'companyName',
        readOnly: info.selected,
        required: true,
      });
    }
    if (!isConsumer) {
      fields.push({
        fieldName: 'firstName',
        kind: 'input',
        label: formatMessage('First Name'),
        name: 'firstName',
        readOnly: info.selected,
        required: true,
      },
      {
        fieldName: 'lastName',
        kind: 'input',
        label: formatMessage('Last Name'),
        name: 'lastName',
        readOnly: info.selected,
        required: true,
      });
    }

    const titleWrapper = (
      <div className={classes.titleBlock}>
        <div>{title}</div>
      </div>
    );

    // const saveButtonDisable = !info.email;
    return (
      <SmartDialog
        noOutsideClick
        onClose={this.handleClose}
        open={open}
        title={titleWrapper}
      >
        <div className="add-source-dialog">
          <AutoFill
            clearInfo={email => this.setState({
              info: { email, selected: false },
              refreshCount: refreshCount + 1,
            })}
            email={info.email}
            info={info}
            isVendor={isVendor}
            onSelect={this.onSelect}
          />
          <SmartForm
            cancelButton={formatMessage('Cancel')}
            defaultData={info}
            fields={fields}
            key={refreshCount}
            onCancel={this.handleClose}
            onSave={this.onSave}
            saveButton={saveButtonTitle !== '' ? saveButtonTitle : title}
            // saveButtonDisable={saveButtonDisable}
          />
        </div>
      </SmartDialog>
    );
  }
}

export default compose(
  setDisplayName('AddSourceDialog'),
  connect(
    () => ({}),
    dispatch => ({
      bulkCreateSocialContacts: payload => dispatch(bulkCreateSocialContacts(payload)),
    }),
  ),
  withStyles(styles),
  injectIntl,
)(AddSourceDialog);
